import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Utilities from './components/utilities';
import NoMatch from './routes/no-match';
import {Home} from './routes/home';


export default function Halo() {
  return (
      <Router basename='/videochecker'>
        <Utilities>
            <Switch>
              <Route exact path="/" component={Home}/>
              <Route component={NoMatch}/>
            </Switch>
        </Utilities>
      </Router>
  );

}
